import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {fetchDataIfReady, setAlert} from '../modules/fetch.action.js'
import {handleChange} from '../modules/functions.js'
import ModalWrapper from '../components/Modal_Wrapper.js'
import i18n_texts from '../i18n.js';

const e = React.createElement;


function ModalLabels(props) {
  React.Component.constructor.call(this);

  var workspace_id = (typeof props.workspace_id !== 'undefined') ? props.workspace_id : null;
  var list_api_block = (typeof props.workspace_id !== 'undefined') ? "label_list_"+props.workspace_id : "label_list";

  this.state = {nw_name:"", nw_background:"#444444", nw_color:"#ffffff", workspace_id:workspace_id, list_api_block:list_api_block};
}
ModalLabels.prototype = Object.create(React.Component.prototype);

ModalLabels.prototype.render = function() {
  if(this.props.shouldShow) {
    var current_labels = null, label_list = this.props.apiData[this.state.list_api_block];

    if(label_list && label_list.isValid) {
      current_labels = label_list.data.map(function(label, i) {
        return e('div', {key:"1_"+i+"_"+label.id}, e('span', {style:{background:"#"+label.background, color:"#"+label.color}}, label.name));
      });
    }

    return e(ModalWrapper, {switchState:this.props.close}, [
      (current_labels !== null && current_labels.length !== 0) && e('div', {key:"labels", className:"contact-labels"}, [current_labels, e('br', {key:"br1"})]),
      e('form', {key:"form", onSubmit:function(e) {this.handleCreate(e)}.bind(this)}, [
        e('div', {key:"input1"}, e('input', {key:"name", type:"text", value:this.state.nw_name, onChange:handleChange.bind(null, this, "nw_name"), placeholder:i18n_texts["gen_name"][this.props.lang]})),
        e('div', {key:"input2"}, [
          e('input', {key:"color1", type:"color", value:this.state.nw_background, onChange:handleChange.bind(null, this, "nw_background"), style:{float:"left", marginRight:"4px"}}),
          e('input', {key:"color2", type:"color", value:this.state.nw_color, onChange:handleChange.bind(null, this, "nw_color"), style:{float:"left", marginRight:"4px"}}),
          (this.state.nw_name !== "") && e('span', {key:"colors", className:"contact-label", style:{background:this.state.nw_background, color:this.state.nw_color, float:"left"}}, this.state.nw_name),
          e('br', {key:"br2", style:{clear:"both"}})
        ]),
        e('div', {key:"submit"}, e('input', {type:"submit", value:i18n_texts["core_settings_save"][this.props.lang], disabled:this.props.label_create_is_fetching})),
        e('i', {key:"hotkey", id:"modal-labels-hook"})
      ])
    ]);
  } else {
    return null;
  }
}

ModalLabels.prototype.handleCreate = function(e) {
  e.preventDefault();
  if(this.state.nw_name.indexOf("\\") >= 0 || this.state.nw_name.indexOf("\"") >= 0) {
    if(this.props.lang === "NL") {
      this.props.setAlert("Ongeldige tekens gebruikt: \\ , \" .");
    } else {
      this.props.setAlert("Used invalid characters: \\ , \" .");
    }
  } else {
    if(this.props.label_create_is_fetching === false || this.props.label_create_is_fetching === null) {
      var payload = {name:this.state.nw_name.replace(new RegExp("'", 'g'), "\\'"), background:this.state.nw_background.replace('#', ''), color:this.state.nw_color.replace('#', '')};
      if(this.state.workspace_id) payload["workspace_id"] = this.state.workspace_id;
      this.props.fetchDataIfReady(this.props.config.api_token, "label_create", "POST", this.props.config.api_url+"/label-create?t="+this.props.session_token, JSON.stringify(payload), null, true, false, true, false, false, null, this.state.list_api_block);
      this.setState({"nw_name":"", "nw_background":"#444444", "nw_color":"#ffffff"});
    }
  }
  return false;
}


function mapStateToProps(state) {
  var session_token = null, label_create_is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["label_create"] !== undefined && state.apiData["label_create"].isFetching !== undefined) {
    label_create_is_fetching = state.apiData["label_create"].isFetching;
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    label_create_is_fetching: label_create_is_fetching,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalLabels)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalLabels.js
// module id = 238
// module chunks = 0